// ListItem.tsx
import { ListItem, Typography, ListItemText, List } from '@mui/material';
import React from 'react';
import { camelCaseToTitleCase } from '../../shared/utils';

const listItemStyle = {
    display: 'list-item',
    listStyleType: 'disc',
    pl: 2,
};

interface ListSectionProps {
    title: string;
    items: string[];
}

export const ListItems = ({ text }: { text: string }) => (
    <ListItem sx={listItemStyle}>
        <ListItemText
            primary={
                <Typography
                    sx={{
                        color: 'text.primary',
                        fontSize: '16px',
                    }}
                >
                    {text}
                </Typography>
            }
        />
    </ListItem>
);

export const ListSection = ({ title, items }: ListSectionProps) => (
    <List sx={{ paddingLeft: 2 }}>
        <Typography sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            {camelCaseToTitleCase(title)}
        </Typography>
        {items.map((text, index) => (
            <ListItems key={index} text={text} />
        ))}
    </List>
);
